import { gql } from '@apollo/client'
import GroupEventFragment from 'fragments/group-event'

export const COACH_ONBOARDING_STATUS = gql`
  query CoachOnboardingStatus(
    $includeMarketplaceListing: Boolean = false
    $upcomingStartDateTime: DateTimeRangeInput
  ) {
    lessonTypes @include(if: $includeMarketplaceListing) {
      id
      status
    }
    currentUser {
      groupEvents(
        startDateTime: $upcomingStartDateTime
        includeCanceled: false
      ) @include(if: $includeMarketplaceListing) {
        startDateTime
        tags
        registrationClosed
        registrationFull
        hasWaitlist
        sessions {
          startDateTime
        }
      }
      attributes {
        ... on Coach {
          coachProfile {
            id
            slug
            status
            bookable
          }
          facilities @include(if: $includeMarketplaceListing) {
            id
            coachProfilesFacilities {
              visible
            }
          }
          canPromoteContent
          bookingUrl
          freeTierLimitsReached
          preferences {
            acceptsLeads
          }
          pgaMembership {
            admCertified
          }
          coachOnboardingProgress {
            coachProfileCreated
            schedulableCreated
            availabilityAdded
            facilityAdded
          }
        }
      }
    }
  }
`

export const BOOKINGS_QUERY = gql`
  query GetCoachBookingsByStartDate(
    $startDateTime: DateTimeRangeInput!
    $orderBy: [ScheduleOrderByInput!]!
    $limit: Int
  ) {
    currentUser {
      schedule(
        startDateTime: $startDateTime
        orderBy: $orderBy
        limit: $limit
      ) {
        __typename
        id
        startDateTime
        endDateTime
        timezone
        isCanceled
        title
        description
        startDateTime
        coachFacility {
          id
          name
          street
          city
          state
          zipCode
        }
        coach {
          id
          name
        }
        enrollments {
          id
          confirmationCode
          createdAt
          isCanceled
          paymentRequestToken
          paymentRequestedDate
          lessonCredit {
            lessonPack {
              id
              lessonPackOffering {
                pricePerLessonInCents
              }
              registrationPayments {
                id
                createdAt
              }
            }
          }
          student {
            id
            firstName
            lastName
            representatives {
              contact {
                externalId
                firstName
                lastName
                email
                phone
              }
            }
            demographicProfile {
              gender
            }
            pgaHopeEmergencyContact {
              id
              firstName
              lastName
              phone
              email
              relationship
            }
            pgaHopeProfile {
              id
              accommodations
              additionalInfo
              golfCareerInterest
              golfExperience
              handedness
              hasOwnClubs
              militaryStatus
              referralSource
              serviceBranch
              serviceYearStart
              serviceYearEnd
            }
            contact {
              id
              firstName
              lastName
              email
              phone
              externalId
            }
          }
          transactions {
            amountInCents
            createdAt
            sourceType
            refund
            registrationPayment {
              id
              products {
                ... on Enrollment {
                  lesson {
                    title
                  }
                }
              }
              registrationPaymentCharge {
                id
                chargeType
                chargeNumber
                checkNumber
              }
            }
          }
        }
        ... on Session {
          lessonType {
            id
            category
            priceInCents
            acceptsOnlinePayments
            durationInMinutes
            paymentAccount {
              deletedAt
              chargesEnabled
              payoutsEnabled
            }
          }
        }
        ... on GroupEvent {
          ${GroupEventFragment}
          paymentAccount {
            deletedAt
            chargesEnabled
            payoutsEnabled
          }
        }
      }
    }
  }
`
